import React, { useEffect, useState } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import {
  NIVELADM,
  CARAC_MANUTENCAO_CIDADES,
  ROUTE_RELATORIO_OCORRENCIAS_CONTAS,
  CARACTERISTICA_VALIDADOR_ASSINATURA_DIGITAL,
  ROUTE_RELATORIO_CIDADES_REGIAO,
  CARACTERISTICA_HOMOLOGADOR,
  CARACTERISTICA_RELATORIO_DADOS_CLIENTE,
  CARACTERISTICA_RELATORIO_DEBITOS_MUNICIPAIS,
  CARACTERISTICA_POSICAO_SINTETICA_CARTEIRA_RECEBER,
  CARACTERISTICAS_APROVACAO_DESPESA,
  ROUTE_AUTORIZA_DESPESA,
  ROUTE_RELATORIO_RAMOS,
  CARACT_EXP_IMP_COTACAO_MOEDA_FORTE,
  ROUTE_EXP_IMP_COTACAO_MOEDA_FORTE,
  ROUTE_ALTERA_NOME_ATIVO,
  ROUTE_RELATORIO_PLANO_CONTAS,
  ROUTE_HISTORICO_PADRAO,
  caracteristicas,
  COBRANCA_IMOVEL,
  CARACTERISTICA_RATEIO_TEMPLATE,
  CADASTRO_CARTAO_TAXA,
  CARACTERISTICA_CONSULTA_CGC_CPF,
  CARACTERISTICA_RASTREAMENTO_TITULOS,
  CARACTERISTICA_MANUTENCAO_TITULO,
  TIPO_ATENDIMENTO_CARACTERISTICA,
  GESTAO_IPTU,
  CARACTERISTICA_RETORNO_BRADESCO,
  RETORNO_COBRANCA_BRADESCO,
  RETORNO_COBRANCA_GERAL,
  CARACTERISTICA_REL_CENTRO_CUSTO,
  CARACTERISTICA_CONTROLE_HORAS_PJ,
  CARACTERISTICA_REL_NEGOCIOS_ACESSO,
  ROUTE_REL_NEGOCIOS,
  CARACTERISTICA_CANCELA_PROPOSTA_MISTA,
  ROUTE_MANUAL_APURACAO,
  CARACTERISTICA_CARTEIRA_CONTA_CAPITAL,
  ROUTE_CARTEIRA_CONTA_CAPITAL,
  ROUTE_CONSULTA_ANIVERSARIANTES,
  CARACTERISTICA_CONSULTA_ANIVERSARIANTES,
  ROUTE_MAPEAMENTO_GERAL_ESTOQUE,
  ROUTE_RELATORIO_RAZAO_SOCIAL,
  CARACTERISTICA_RELATORIO_RAZAO_SOCIAL,
  CARACTERISTICA_PORTADOR_JURIDICO,
  ROUTE_PORTADOR_JURIDICO,
  CARACTERISTICA_RELAT_COMISSAO_IMOVEIS,
  CARACTERISTICA_COBRADOR_GERENCIAL,
  CARACTERISTICA_COBRADOR_OPERACIONAL,
  ROUTE_TRANSF_COBRANCA,
  RBAC_RESULTADO_ATENDIMENTO,
  ROUTE_RESULTADO_ATENDIMENTO,
  CARACTERISTICA_BAIXA_TITULO,
  CARACTERISTICA_ACERTAR_CONTA,
  ROUTE_ACERTAR_CONTA,
  CARACTERISTICA_ALTERAR_CODIGO_CONTA,
  ROUTE_ALTERAR_CODIGO_CONTA,
  CARACTERISTICA_ALTERAR_CODIGO_DEPARTAMENTO,
  ROUTE_ALTERAR_CODIGO_DEPARTAMENTO,
  ROUTE_CONSULTA_OCORRENCIAS_ATIVO,
  CARAC_REAPRESENTAR_CHEQUES,
  CARAC_COMUNICADO_EMAIL,
  CARACTERISTICA_TRANSFERENCIA_OCORRENCIAS,
  ROUTE_TRANSFERENCIA_OCORRENCIAS,
  CARACTERISTICA_CONCILIACAO_BANCARIA,
  ROUTE_CONCILIACAO_BANCARIA,
  MATRICIAL_CONTROLADORIA,
  CARACTERISTICA_MONITORAMENTO,
  CARACTERISTICA_ESTORNO_TITULO,
  ROUTE_ESTORNO_BAIXA_TITULO,
  CARACTERISTICA_FECHA_CAIXA,
  ROUTE_FECHAMENTO_CAIXA,
  MENU_GERENCIA_EMAIL,
  CARACTERISTICA_ATA_CONTABIL,
  CARACTERISTICA_RELATORIO_REMESSA_BOLETOS,
  ROUTE_RELATORIO_REMESSA_BOLETOS,
  ROUTE_CONTAS_PREFEITURA_SEM_CONVENIO,
  CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF,
  ROUTE_RELAT_CONTAS_SEM_SALDO_CONF,
  ROUTE_PARAMETROS_SISTEMA_FUSAO,
  CARACTERISTICA_LOCAL_ATENDIMENTO,
  CARACTERISTICA_ACESSO_JURIS,
  ROUTE_CONTAS_ISENTAS_JURIDICO,
  ROUTE_RELATORIO_VENDAS_DESCONTO,
  CARACTERISTICA_AUDITORIA,
  ROUTE_CHEQUES_PRORROGADOS,
  ROUTE_HISTORICO_IMOVEIS,
  CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA,
  CARACTERISTICA_GENERATE_MANUTENCAO,
  ROUTE_RELACIONAMENTO_CONTAS,
  ROUTE_LISTA_EMAIL_CLIENTES,
  CARACTERISTICA_EVENTO_RSVP,
  CARACTERISTICA_CHECKIN_PESQUISA_EVENTO,
  ROUTE_EVENTOS_RSVP,
  ROUTE_EVENTO_RSVP_CHECKIN,
  ROUTE_PESQUISA_EVENTO,
  CARACTERISTICA_IMPLANTA_REEMBOLSAVEIS,
  ROUTE_COTACOES_MOEDA_FORTE,
  CHAR_SALDO_CONTAS_CONFERIR,
  ROUTE_SALDOS_CONTAS,
  CARACTERISTICA_CONTAS_DIF_LIQ,
  ROUTE_CONTAS_DIF_LIQ,
  CARACTERISTICA_IMPORTACAO_XLS_CONTAS,
  ROTA_SIMULA_COMISSAO_COBRANCA,
  ROTA_GERADOR_ASSINATURA_EMAIL,
  CARACTERISTICA_CONTATOS_TESTE,
  ROUTE_PARAMETROS_CONTATOS_TESTE,
  ROUTE_IMOVEIS_ESTOQUE,
  CARACTERISTICA_RELATORIO_CONTAS,
  ROUTE_ETIQUETAS_CARTAS,
} from '~/constant';
import { isAmbienteProducao } from '~/Pages/Vendas/helpers';

import App from '~/Components/App';
import Login from '~/Pages/Login';
import ProspectoLista from '~/Pages/ProspectoLista';
import ProspectoDetalhes from '~/Pages/ProspectoDetalhes';
import Produtividade from '~/Pages/Produtividade';
import Comissao from '~/Pages/Comissao';
import Vendas from '~/Pages/Vendas';
import AnexarComprovante from '~/Pages/AnexarComprovante';
import AtendimentoCorretor from '~/Pages/AtendimentoCorretor';
import AtendimentoGerente from '~/Pages/AtendimentoGerente';
import LancamentoSolicitacoes from '~/Pages/LancamentoSolicitacoes/LancamentoSolicitacoes';
import LancamentoAvaliacao from '~/Pages/LancamentoAvaliacao/LancamentoAvaliacao';
import PesquisaPosVenda from '~/Pages/PesquisaPosVenda';
import PesquisaEvento from '~/Pages/PesquisaEvento';
import LancamentoSequenciaAtendimento from '~/Pages/LancamentoSequenciaAtendimento/LancamentoSequenciaAtendimento';
import PropostaEstorno from '~/Pages/Proposta/PropostaEstorno';
import RankingCorretores from '~/Pages/RankingCorretores';
import RankingCorretoresTrimestre from '~/Pages/RankingCorretoresTrimestre';
import PrivateRoute from './PrivateRoute';
import Prospectos from '~/Pages/Prospectos';
import AtribuirProspectos from '~/Pages/AtribuirProspectos';
import Agendamento from '~/Pages/Agendamento';
import ConfiguracoesFluxoProspecto from '~/Pages/Configuracoes/FluxoProspecto';
import GerenciamentoRankingCampanha from '~/Pages/Configuracoes/GerenciamentoRankingCampanha';
import DocumentoDigitalOld from '~/Pages/DocumentoDigital';
import ClickSignDocumentoDigital from '~/Pages/ClickSignDocumentoDigital';
import DocumentoDigitalSwitch from '~/Pages/DocumentoDigitalSwitch';
import CobrancaInadimplencia from '~/Pages/CobrancaInadimplencia';
import ConsultaAcordoJudicial from '~/Pages/Cobrador/ConsultaAcordoJudicial';
import AutorizacaoVenda from '~/Pages/AutorizacaoVenda';
import TestPage from '~/Pages/TestPage';
import ImportarLead from '~/Pages/ImportarLead/ImportarLead';
import ConsultarDescontos from '~/Pages/ConsultarDescontos';
import AuthStorage from '~/Utils/AuthStorage';
import CardSituacaoDetalhada from '~/Components/StatusSituacaoCliente/CardSituacaoDetalhada';
import EditorMioloContrato from '~/Pages/EditarMioloContrato';
import mapaHumanizado from '~/Pages/MapaHumanizado/Index';
import VendaGravada from '~/Components/Vendas/VendaGravada';
import AdmVendas from '~/Pages/AdmVendas/index';
import NotificaoLancamento from '~/Components/NotificacaoLancamento';
import RelatorioEstorno from '~/Pages/RelatorioEstorno';
import PropostaRapida from '~/Pages/Relatorios/Comercial/PropostaRapida';
import PesquisaDocumentoDigital from '~/Pages/PesquisaDocumentoDigital/index';
import ControleDocumentoDigital from '~/Pages/PesquisaDocumentoDigital/ControleDocumentoDigital';
import cancelarDocDgital from '~/Pages/CancelarDocDigital/cancelarDocDigital';
import LeadGestaoTela from '~/Components/Prospectos/ProspectoDetalhes/GestaoProspecto';
import ProdutividadeCobradores from '~/Pages/ProdutividadeCobradores';
import painelRmm from '~/Pages/painelRmm/painelRmm';
import AgendaLeads from '~/Components/Prospectos/Agenda';
import LancamentoBaixarSenhaComprador from '~/Pages/LancamentoBaixarSenhaComprador/LancamentoBaixarSenhaComprador';
import ParametrosPDV from '~/Pages/ParametrosPDV';
import ParametrosDetalhes from '~/Pages/ParametrosPDV/parametrosDetalhes';
import ParametrosIntegracao from '~/Pages/ParametrosIntegracao';
import ParametrosFusao from '~/Pages/ParametrosFusao';
import ParametrosContatosTeste from '~/Pages/ParametrosContatosTeste';
import TagsAtendimento from '~/Components/Prospectos/TagsAtendimento/TagsAtendimento';
import Usuarios from '~/Pages/Usuarios';
import ConfiguracoesUsuarios from '~/Pages/Usuarios/usuario';
import GruposUsuario from '~/Pages/GruposUsuario';
import Caracteristicas from '~/Pages/Caracteristicas';
import RoletaLeads from '~/Pages/RoletaLeads';
import { RelatorioAlcadas } from '~/Pages/RelatorioAlcadas';
import RelatorioPosVenda from '~/Pages/RelatorioPosVenda';
import RelatorioEscalas from '~/Pages/RelatorioEscalas';
import { ConsultarProcessosJudiciais } from '~/Pages/Juridico';
import ControleContrato from '~/Pages/Juridico/ControleContrato';
import PrestadoresHorasPJ from '~/Pages/Juridico/HorasPJ/Prestadores';
import FechamentoHorasPJ from '~/Pages/Juridico/HorasPJ/Fechamento';
import ContratosHorasPJ from '~/Pages/Juridico/HorasPJ/Contratos';
import FundosHorasPJ from '~/Pages/Juridico/HorasPJ/Fundos';
import RescisaoHorasPJ from '~/Pages/Juridico/HorasPJ/Rescisao';
import RelatoriosHorasPJ from '~/Pages/Juridico/HorasPJ/Relatorios';
import ContasIsentasJuridico from '~/Pages/ContasIsentasJuridico';
import RelatorioProspectos from '~/Pages/ConversaoLeads';
import { RelatorioRankingVendas } from '~/Pages/RelatorioRankingVendas';
import { RelatorioVendasDesconto } from '~/Pages/RelatorioVendasDesconto';
import { RelatorioRescisoes } from '~/Pages/RelatorioRescisoes';
import ControlePdv from '~/Pages/ControlePdv';
import ListarTabelaDePrecos from '~/Pages/ListarTabelaDePreco';
import AlterarSenha from '~/Pages/AlterarSenha';
import IndicacaoPage from '~/Pages/Indicacao';
import Impressao from '~/Pages/Impressao';
import VisualizarPDF from '~/Pages/VisualizarPDF';
import { RelatorioInatividadeLeads } from '~/Pages/RelatorioInatividade';
import { GerenciamentoMassa } from '~/Pages/RelatorioAtribuicaoEtapas';
import LotesDisponiveis from '~/Pages/LotesDisponiveis/Index';
import RelatorioAutoAtendimento from '~/Pages/RelatorioAutoAtendimento';
import PrecificacaoAtivosPage from '~/Pages/PrecificacaoAtivos';
import AtivoManutencao from '~/Pages/AtivoManutencao';
import LancamentoCompraImobilizado from '~/Pages/LancamentoCompraImobilizado';
import Procuracoes from '~/Pages/Procuracoes';
import CasasDisponiveis from '~/Pages/CasasDisponiveis';
import ImoveisDisponiveis from '~/Components/ImoveisDisponiveis';
import EmpreendimentosContaBancaria from '~/Pages/EmpreendimentosContaBancaria';
import SolicitacoesCessoes from '~/Pages/SolicitacoesCessoes';
import GestaoRescisoes from '~/Pages/GestaoRescisoes';
import Mesas from '~/Pages/Lancamento/mesas';
import FichaEmpreendimentos from '~/Pages/FichaEmpreendimentos';
import DefinirMesaEAtendimento from '~/Pages/DefinirMesaEAtendimento';
import HierarquiaComercial from '~/Pages/HierarquiaComercial';
import RelatorioLeadsVendas from '~/Pages/RelatorioLeadsVendas';
import SolicitacoesEscritura from '~/Pages/SolicitacoesEscritura';
import BaseConhecimento from '~/Pages/BaseConhecimento';
import Treinamento from '~/Pages/Treinamento';
import HubRelatorios from '~/Pages/HubRelatorios';
import Campanhas from '~/Pages/Campanhas';
import MapaEmprendimento from '~/Pages/MapaEmpreendimento';
import SimuladorFinanceiro from '~/Pages/SimuladorFinanceiro';
import ReservasPendentes from '~/Pages/ReservasPendentes';
import FilaLote from '~/Pages/FilaLote';
import PreEncaminhamento from '~/Pages/Lancamento/preencaminhamento';
import Encaminhamento from '~/Pages/Lancamento/encaminhamento';
import EncaminhamentoAssinatura from '~/Pages/Lancamento/encaminhamentoassinatura';
import RelatorioConferencia from '~/Pages/RelatorioConferencia';
import ParametrosRenegociacao from '~/Pages/ParametrosRenegociacao';
import RelatorioVendasImobiliaria from '~/Pages/RelatorioVendasImobiliaria';
import ConsultaAcesso from '~/Pages/ConsultaAcesso';
import RelatorioVendasEmpreendimento from '~/Pages/RelatorioVendasEmpreendimento';
import RelatorioVendasTrimestre from '~/Pages/RelatorioVendasTrimestre';
import RelatorioAtendimentoLancamento from '~/Pages/RelatorioAtendimentoLancamento';
import VisaoLancamento from '~/Pages/VisaoLancamento';
import RelatorioEstoque from '~/Pages/RelatorioEstoque';
import RelatorioMotivosNaoCompra from '~/Pages/RelatorioMotivosNaoCompra';
import RelatorioVendasValorVista from '~/Pages/RelatorioVendasValorVista';
import RelatorioInteressesLote from '~/Pages/RelatorioInteressesLote';
import ComissaoCorretor from '~/Pages/ComissaoCorretor';
import RelatorioProspectosPastas from '~/Pages/RelatorioProspectosPastas';
import RelatorioPesquisaProspecto from '~/Pages/RelatorioPesquisaProspecto';
import RelatorioLancamento from '~/Pages/RelatorioLancamento';
import RelatorioFilaLote from '~/Pages/RelatorioFilaLote';
import RelatorioDebitos from '~/Pages/RelatorioDebitos';
import RelatorioCidades from '~/Pages/RelatorioCidades';
import RelatorioCidadesPorRegiao from '~/Pages/RelatorioCidadesPorRegiao';
import RelatorioRamos from '~/Pages/Relatorios/Ramos';
import EstornoReaprCheque from '~/Pages/Financeiro/EstornoReaprCheque';
import EstornoBaixaTitulo from '~/Pages/EstornoBaixaTitulo';
import ContasSaldoDisponivel from '~/Pages/ContasSaldoDisponivel';
import Cidades from '~/Pages/Cidades';
import CadastroImobiliarias from '~/Pages/CadastroImobiliarias';
import ControleBrindes from '~/Pages/ControleBrindes';
import ConsultarSaldos from '~/Pages/ConsultarSaldos';
import TabelaPrecos from '~/Pages/TabelaPrecos';
import EmpreendimentoConfig from '~/Pages/EmpreendimentoConfig';
import QualidadeAtivo from '~/Pages/QualidadeAtivo';
import QualidadesAtivo from '~/Pages/QualidadesAtivo';
import PortadorUsuario from '~/Pages/PortadorUsuario';
import CategoriaDepartamento from '~/Pages/CategoriaDepartamento';
import RamosAtividade from '~/Pages/RamosAtividade';
import TipoContaInterna from '~/Pages/GES/Contas/Tabelas/TipoContaInterna';
import ContasDificilLiquidacao from '~/Pages/GES/Contas/ContasDificilLiquidacao';
import HistoricoPadrao from '~/Pages/HistoricoPadrao';
import CategoriasContas from '~/Pages/CategoriasContas';
import Departamento from '~/Pages/Departamento';
import Parcerias from '~/Pages/Parcerias';
import EdicaoParceria from '~/Pages/Parcerias/Edicao';
import Paises from '~/Pages/Paises';
import ConsultaImoveis from '~/Pages/ConsultaImoveis';
import Regioes from '~/Pages/Regioes';
import DespesaTipoPagamento from '~/Pages/DespesaTipoPagamento';
import CentroCusto from '~/Pages/Negocios/CentroCusto';
import RemanejamentoCaixa from '~/Pages/RemanejamentoCaixa';
import RestringirAcesso from '~/Pages/RestringirAcesso';
import IntencoesVendas from '~/Pages/IntencoesVendas';
import LogAtualizacoes from '~/Pages/LogAtualizacoes';
import RelDespesaDeptoPage from '~/Pages/Relatorios/DespesaDepto';
import RelDigitalizacaoPage from '~/Pages/Relatorios/Digitalizacao';
import RelatorioVariantesAtivoPage from '~/Pages/Relatorios/VariantesAtivo';
import RelatorioAtivoFamilia from '~/Pages/RelatorioAtivoFamilia';
import RelatorioComissaoImoveis from '~/Pages/RelatorioComissaoImoveis';
import RelatorioDespesasAnalitico from '~/Pages/GES/Relatorios/Despesas/Analitico';
import GrupoEmpresa from '~/Pages/GrupoEmpresa';
import GrupoEmpresaDetalhes from '~/Pages/GrupoEmpresa/Detalhes';
import CadastroUnicoFornecedor from '~/Pages/CadastroUnicoFornecedor';
import ContaListagem from '~/Pages/Contas';
import ContaDetalhe from '~/Pages/Contas/Detalhe';
import GrupoFamilias from '~/Pages/GrupoFamilias';
import FamiliasAtivos from '~/Pages/FamiliasAtivos';
import VariantesAtivo from '~/Pages/VariantesAtivo';
import ContasSalario from '~/Pages/ContasSalario';
import CadastroPdv from '~/Pages/CadastroPdv';
import Cotacoes from '~/Pages/Cotacoes';
import CotacoesMoedaForte from '~/Pages/CotacoesMoedaForte';
import FAQ from '~/Pages/FAQ';
import EnquadramentoGuarulhos from '~/Pages/EnquadramentoGuarulhos';
import Solicitacoes from '~/Pages/Solicitacoes';
import Feriados from '~/Pages/Feriados';
import LancamentoCadastroRapido from '~/Pages/LancamentoCadastroRapido';
import ContasUsuario from '~/Pages/ContasUsuario';
import ContasBloqueadasExtrato from '~/Pages/GES/ContasBloqueadas';
import OcorrenciasImoveis from '~/Pages/OcorrenciasImoveis';
import ConsultaOcorrenciasContas from '~/Pages/ConsultaOcorrenciasContas';
import ImportacaoAtivos from '~/Pages/ImportacaoAtivos';
import ImportacaoContas from '~/Pages/ImportacaoContas';
import AjustarDadosImoveis from '~/Pages/AjustarDadosImoveis';
import ImoveisRescindidos from '~/Pages/ImoveisRescindidos';
import ImoveisVendidos from '~/Pages/ImoveisVendidos';
import DocVenda from '~/Pages/DocVenda';
import RedutoresDesconto from '~/Pages/RedutoresDesconto';
import RastreamentoTitulos from '~/Pages/RastreamentoTitulos';
import ConsultaCgcCpf from '~/Pages/ConsultaCgcCpf';
import TipoAtendimento from '~/Pages/TipoAtendimento';
import RelatorioCotacaoMoedaForte from '~/Pages/RelatorioCotacaoMoedaForte';
import DeclaracaoQuitacao from '~/Pages/DeclaracaoQuitacao';
import ExportacaoImportacaoCotacaoMoedaForte from '~/Pages/GES/Ferramentas/ExportacaoImportacaoCotacaoMoedaForte';
import AlteraNomeAtivo from '~/Pages/GES/Ferramentas/AlteraNomeAtivo';
import AcertarConta from '~/Pages/GES/Ferramentas/AcertarConta';
import AlterarCodigoConta from '~/Pages/GES/Ferramentas/AlterarCodigoConta';
import AlterarCodigoDepartamento from '~/Pages/GES/Ferramentas/AlterarCodigoDepartamento';
import FechamentoCaixa from '~/Pages/GES/Ferramentas/FechamentoCaixa';
import DespesaCartaoCredito from '~/Pages/DespesaCartaoCredito';
import FechamentoCartaoCredito from '~/Pages/FechamentoCartaoCredito';
import FamiliasAtivosRelatorio from '~/Pages/Relatorios/FamiliasAtivos';
import RelatorioContasPage from '~/Pages/Relatorios/RelatorioContas/index';
import RelatorioQualidadesAtivos from '~/Pages/Relatorios/QualidadesAtivos';
import RelatorioAnaliseEmpreendimento from '~/Pages/Relatorios/AnaliseEmpreendimento';
import RefinanciamentosInadimplencia from '~/Pages/Relatorios/Cobranca/RefinanciamentosInadimplencia';
import ListaAtivos from '~/Pages/ListaAtivos';
import PosicaoCobranca from '~/Pages/Imob/Cobranca/PosicaoCobranca';
import UsuarioAlternativoMatricial from '~/Pages/MatricialDespesas/UsuarioAlternativo';
import MatricialPeriodos from '~/Pages/MatricialDespesas/Periodos';
import NivelRetencao from '~/Pages/GES/Negocios/NivelRetencao';
import Digitalizacao from '~/Pages/Digitalizacao';
import IsencaoCobranca from '~/Pages/Imob/IsencaoCobranca';
import CancelamentoMista from '~/Pages/Imob/CancelamentoMista';
import TransferirTitulos from '~/Pages/Imob/Cobrador/TransferirTitulos';
import ResultadoAtendimento from '~/Pages/Imob/Cobrador/ResultadoAtendimento';
import GerenciamentoEmail from '~/Pages/Imob/GerenciamentoEmail';
import AtaContabil from '~/Pages/Imob/AtaContabil';
import LocalAtendimento from '~/Pages/Imob/LocalAtendimento';
import ComunicadoQuitacao from '~/Pages/Atendimento/ComunicadoQuitacao';
import AlineaPage from '~/Pages/GES/Relatorios/Titulos/Alinea';
import RelCentroCusto from '~/Pages/GES/Relatorios/Contas/CentroCusto';
import RelNegocios from '~/Pages/GES/Relatorios/Negocios';
import Aniversariantes from '~/Pages/GES/Aniversariantes';
import OcorrenciasContas from '~/Pages/GES/Relatorios/Contas/OcorrenciasContas';
import CarteiraPorContaCapital from '~/Pages/GES/CarteiraPorContaCapital';
import RazaoSocial from '~/Pages/Imob/Relatorios/Contabil/RazaoSocial';
import AcordosNaoConcretizados from '~/Pages/Relatorios/Cobranca/AcordosNaoConcretizados';
import ContasIntercambio from '~/Pages/ContasIntercambio';
import ContasSemSaldoConferido from '~/Pages/Audit/ContasSemSaldoConferido';
import SimulacaoProposta from '~/Pages/GES/SimulacaoProposta';
import Cartoes from '~/Pages/GES/Cartoes';
import PerfilCarteiraPorFaixa from '~/Pages/PerfilCarteiraPorFaixa';
import BaixaPorData from '~/Pages/GES/Negocios/Titulos/BaixaPorData';
import CorrecaoTitulos from '~/Pages/GES/Negocios/Titulos/CorrecaoTitulos';
import AutorizaDespesa from '~/Pages/GES/Negocios/AutorizaDespesa';
import ChequesDevolvidosPage from '~/Pages/GES/RelatoriosTitulos/ChequesDevolvidos';
import HistoricoPadraoGES from '~/Pages/GES/Relatorios/HistoricoPadrao';
import ControleTaxaTransferencia from '~/Pages/Atendimento/ControleTaxaTransferencia';
import AtualizaTaxaTransferencia from '~/Pages/Administracao/AtualizaTaxaTransferencia';
import DebitosMunicipais from '~/Pages/Atendimento/DebitosMunicipais';
// W-0564 — Templates de Rateio
import RateioTemplate from '~/Pages/RateioTemplate';
import GestaoIPTU from '~/Pages/GestaoIPTU';
// W-0611 — Saldo de Conta Banco
import SaldoContaBanco from '~/Pages/GES/Gerencial/SaldoContaBanco';
// W-0612 — Fluxo de Caixa Gerencial
import FluxoCaixa from '~/Pages/GES/Gerencial/FluxoCaixa';
// W-0613 — Posição Sintética Carteira a Receber
import PosicaoSinteticaCarteiraReceber from '~/Pages/GES/Gerencial/Financas/PosicaoSinteticaCarteiraReceber';
// W-0617 — Mapeamento Geral Estoque
import MapeamentoGeralEstoque from '~/Pages/GES/Gerencial/MapeamentoGeralEstoque';
// W-0879 — Retorno Cobrança BRADESCO sem registro
import RetornoCobrancaBradesco from '~/Pages/Generate/RetornoCobrancaBradesco';
// W-0882 — Retorno Cobrança - Geral (CEF/BRADESCO/TIVIT/SANTANDER)
import RetornoCobranca from '~/Pages/RetornoCobranca';
// W-0881 — Conciliação Bancária - Geral
import ConciliacaoBancariaGeral from '~/Pages/Generate/Retorno/ConciliacaoBancariaGeral';
// W-0872 — Relatório Remessa de Boletos
import RelatorioRemessaBoletos from '~/Pages/Relatorios/RemessaBoletos';
// W-0634 — Manual de Apuração de Resultados
import ManualApuracao from '~/Pages/Gerencial/ManualApuracao';
// W-0724 — Portador Jurídico (Imob)
import PortadorJuridico from '~/Pages/PortadorJuridico';
// W-0693 — Alertas de Empreendimentos (Imob > Administração)
import AlertasEmpreendimentos from '~/Pages/Imob/AlertasEmpreendimentos';
// W-0489 — Consulta de Ocorrências de Ativos (ERP→Web)
import ConsultaOcorrenciasAtivoPage from '~/Pages/GES/ConsultaOcorrenciasAtivo';
// W-0560 — Reapresentação de Cheques Devolvidos
import ReapresentacaoCheques from '~/Pages/GES/ReapresentacaoCheques';
import ManutencaoTitulos from '~/Pages/GES/ManutencaoTitulos';
// W-0490 — Transferência de Ocorrências (GES > Ferramentas)
import TransferenciaOcorrencias from '~/Pages/GES/Ferramentas/TransferenciaOcorrencias';
import ListaEmailClientes from '~/Pages/GES/Ferramentas/ListaEmailClientes';
// W-0753 — Imob_Relatórios_Administração_Ficha de Empreendimento
import FichaEmpreendimentoRelatorio from '~/Pages/Relatorios/FichaEmpreendimento';
// W-0750 — Imob_Relatórios_Administração_Etiquetas Imóveis
import EtiquetasImoveis from '~/Pages/Relatorios/EtiquetasImoveis';
// W-0743 — Imob > Relatórios > Administração > Atualização Cadastral Prefeitura/Água
import AtualizacaoCadastral from '~/Pages/Imob/AtualizacaoCadastral';
// W-0604 — GES Etiquetas/Cartas (emissão em lote)
import EtiquetasCartas from '~/Pages/GES/EtiquetasCartas';
import SimulaComissaoCobranca from '~/Pages/Cobranca/SimulaComissaoCobranca';
// DW-0996 — Sistema RSVP Eventos (Admin CRM)
import EventoRsvpList from '~/Pages/EventoRsvp';
import EventoRsvpForm from '~/Pages/EventoRsvp/EventoFormPage';
import EventoRsvpCheckin from '~/Pages/EventoRsvpCheckin';
// W-0531 — Solicita Reembolso Clientes (IPTU) — Imob > Administração
import ReembolsoIptu from '~/Pages/Imob/ReembolsoIptu';
// W-0698 — Monitoramento de clientes (Imob/Administração)
import Monitora from '~/Pages/Imob/Monitora';
// W-0539 — Contas Prefeitura Sem Convênio
import ContasPrefeituraSemConvenio from '~/Pages/ContasPrefeituraSemConvenio';
// W-0935 — Cheques Prorrogados (módulo Auditoria)
import ChequesProrrogados from '~/Pages/ChequesProrrogados';
// W-0937 — Histórico de Imóveis (módulo Auditoria)
import HistoricoImoveis from '~/Pages/Relatorios/Audit/HistoricoImoveis';
// W-0777 — Relatório Estoque Disponível Imob (Imob > Relatórios > Contábil)
import RelatorioEstoqueContabil from '~/Pages/Imob/RelatorioEstoqueContabil';
// W-0858 — Relacionamento de Contas (Generate > Manutenção)
import RelacionamentoContas from '~/Pages/Generate/RelacionamentoContas';
// W-0883 — Consulta Protocolo de Remessas (Generate > Consulta, read-only)
import ProtocoloRemessas from '~/Pages/ProtocoloRemessas';
import ComunicadoInterno from '~/Pages/ComunicadoInterno';
import SolicitacoesJuridicas from '~/Pages/SolicitacoesJuridicas';
import ContratoConstrucao from '~/Pages/ContratosConstrucao';
import CobrancaSms from '~/Pages/CobrancaSms';
import EnvioSmsJuridico from '~/Pages/Imob/Juridico/EnvioSms';
import ValidadorAssinaturaDigital from '~/Pages/ValidadorAssinaturaDigital';
import CartaoCredito from '~/Pages/CartaoCredito';
import AtualizaVencimentoTitulo from '~/Pages/AtualizaVencimentoTitulo';
// W-0540 — Saldos de Contas (GES > Contas > Saldos de Contas)
import SaldosContas from '~/Pages/GES/SaldosContas';
import AprovacaoPagamentos from '~/Pages/GES/AprovacaoPagamentos';
import RelatorioPlanoContas from '~/Pages/Financeiro/RelatorioPlanoContas';
import RelDebitosMunicipais from '~/Pages/CDM/RelDebitosMunicipais';
import AlertasClientes from '~/Pages/AlertasClientes';
import ImoveisAlugados from '~/Pages/ImoveisAlugados';
import BaixaTitulo from '~/Pages/Relatorios/Contabil/BaixaTitulo';
import ConciliacaoRecebimentos from '~/Pages/Relatorios/Cobranca/ConciliacaoRecebimentos';
import DemonstrativoFinanceiroPage from '~/Pages/Relatorios/Carteira/DemonstrativoFinanceiro';
import CadastroAlinea from '~/Pages/GES/Cadastros/Alinea';
import ConsultaCPF from '~/Pages/ConsultaCPF';
// W-0477 — Relatório Comissão Retida
import ComissaoRetida from '~/Pages/ComissaoRetida';
import GeradorAssinaturaEmail from '~/Pages/GeradorAssinaturaEmail';
// W-0759 — Imóveis em Estoque (Relatório Comercial Imob)
import ImoveisEstoque from '~/Pages/Imob/ImoveisEstoque';
import FluxoCaixaDw from '~/Pages/Relatorios/FluxoCaixaDw';

const Routes = () => (
  <App>
    <Switch>
      <PrivateRoute hasDashboard path="/agendamento" component={Agendamento} />
      <PrivateRoute
        hasDashboard
        path="/pesquisa"
        component={LancamentoAvaliacao}
      />
      <PrivateRoute
        hasDashboard
        path="/cliente/pesquisa/contratos/:codigo_boleto"
        component={PesquisaPosVenda}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/cliente/pesquisa/situacao/:cpf"
        component={CardSituacaoDetalhada}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/lancamento/atendimento/corretor"
        component={AtendimentoCorretor}
      />
      <PrivateRoute
        hasDashboard
        path="/lancamento/atendimento/gerente"
        component={AtendimentoGerente}
      />
      <PrivateRoute
        hasDashboard
        path="/atendimento/consulta-cpf"
        component={ConsultaCPF}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      <Route
        path="/lancamento/solicitacoes"
        component={LancamentoSolicitacoes}
      />
      <Route
        path="/lancamento/compensacao"
        component={LancamentoSequenciaAtendimento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/arquivos/ge/:ge/prevenda/:prevenda/qd/:qd/lt/:lt/familia/:familia" // ajeitar depois
        component={AnexarComprovante}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/produtividade"
        component={Produtividade}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/comissao"
        component={Comissao}
      />
      <PrivateRoute
        path="/comercial/ranking/corretor"
        component={RankingCorretores}
        hasDashboard
      />
      <PrivateRoute
        path="/comercial/ranking/trimestre"
        component={RankingCorretoresTrimestre}
        hasDashboard
      />
      <PrivateRoute
        path="/tabela-precos"
        component={ListarTabelaDePrecos}
        hasDashboard
      />
      <PrivateRoute
        path="/vendas"
        component={Vendas}
        authorizationEvaluator={
          () => AuthStorage.temCaracteristicas([196]) //o intuito dessa rota é realizar aprovações
        }
        exact
        hasDashboard
      />
      <PrivateRoute
        path="/vendas/contraproposta"
        component={Vendas}
        exact
        hasDashboard
      />
      <PrivateRoute
        path="/vendas/prospecto/:prospecto/empreendimento/:empreendimento"
        component={Vendas}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([216])}
        exact
        hasDashboard
      />
      <PrivateRoute
        path="/vendas/autorizacao"
        component={AutorizacaoVenda}
        exact
        hasDashboard
      />
      <PrivateRoute
        path="/vendas/controle-pdv"
        component={ControlePdv}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([279, 295, 347])
        }
        exact
        hasDashboard
      />
      <PrivateRoute path="/comercial/ranking" component={RankingCorretores} />
      <PrivateRoute
        hasDashboard
        path="/prospectos/lista"
        exact
        component={ProspectoLista}
      />
      <PrivateRoute
        hasDashboard
        path="/prospectos/lista/:id/:tab?/:subtab?"
        component={ProspectoDetalhes}
      />
      <Redirect
        path="/prospectos/:id/:tab?/:subtab?"
        to="/prospectos/lista/:id"
      />
      <PrivateRoute hasDashboard path="/prospectos" component={Prospectos} />
      <PrivateRoute
        hasDashboard
        path="/atribuir/prospecto"
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([201, 199])
        }
        component={AtribuirProspectos}
      />
      <PrivateRoute
        hasDashboard
        path="/documentodigitalold"
        component={DocumentoDigitalOld}
      />
      <PrivateRoute
        hasDashboard
        path="/documentodigital"
        component={DocumentoDigitalSwitch}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/clicksign-documento-digital"
        component={ClickSignDocumentoDigital}
        exact
      />
      {/* W-0556 — Estorno de efetivacao usa a rota existente. */}
      <PrivateRoute
        hasDashboard
        path="/proposta/estorno/solicitacoes"
        level={[NIVELADM]}
        component={PropostaEstorno}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([277])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/prospecto/fluxo"
        component={ConfiguracoesFluxoProspecto}
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/campanha"
        component={GerenciamentoRankingCampanha}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicaGerParametros()
        }
      />
      <PrivateRoute
        hasDashboard
        path="/inadimplencia"
        component={CobrancaInadimplencia}
      />
      <PrivateRoute
        hasDashboard
        path="/imob/cobrador/cobranca-sms"
        component={props => <CobrancaSms {...props} modo="C" />}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(86)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/imob/juridico/envio-sms"
        component={EnvioSmsJuridico}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(693)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/crm/importar"
        component={ImportarLead}
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/gestao-iptu"
        component={GestaoIPTU}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(GESTAO_IPTU)
        }
      />
      <Route path="/login" component={Login} />
      <PrivateRoute hasDashboard path="/test" component={TestPage} />
      <PrivateRoute
        hasDashboard
        path="/contrato/empreendimento/:id"
        component={EditorMioloContrato}
      />

      <Route
        hasDashboard
        path="/notificacao/departamento"
        component={NotificaoLancamento}
      />
      <PrivateRoute
        hasDashboard
        path="/ConsultarDesconto"
        component={ConsultarDescontos}
      />
      <PrivateRoute
        hasDashboard
        path="/AdministracaoVendas"
        component={AdmVendas}
      />
      {/* W-0766 — char 630 como portão de migração HML. */}
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/estorno"
        component={RelatorioEstorno}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0763 — Proposta Rápida (Relatórios > Comercial). Char 178 ('Proposta Rapida',
          = char-GES) + char 630 (CARACTERISTICA_HOMOLOGADOR = portão de migração, LICOES §1.8).
          Remover 630 na promoção HML→DONE. */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/comercial/proposta-rapida"
        component={PropostaRapida}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR, 178])
        }
        exact
      />
      {/* W-0797 — Imob > Cobrança > Posição Cobrança. RBAC server-side (char 86 +
          sojuris/pezao); char 630 (MigracaoERP) é o portão de migração HML, ortogonal
          a RBAC — remover na promoção HML→DONE. */}
      <PrivateRoute
        hasDashboard
        path="/imob/cobranca/posicao-cobranca"
        component={PosicaoCobranca}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/financeiro/estorno-reapr-cheque"
        component={EstornoReaprCheque}
        exact
      />
      {/* W-0553 — Estorno de baixa de títulos (LICOES §1.8: char 630 portão de migração) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ESTORNO_BAIXA_TITULO}
        component={EstornoBaixaTitulo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ESTORNO_TITULO)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/documentoDigital/lancamento"
        component={PesquisaDocumentoDigital}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([556])}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/documentoDigital/controle"
        component={ControleDocumentoDigital}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([557])}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/documentoDigital/Cancelar"
        component={cancelarDocDgital}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([561])}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/mapa/:codigo?"
        component={mapaHumanizado}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/cobradores"
        component={ProdutividadeCobradores}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([567, 568])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/prospecto/gestao-crm/:codigo"
        component={LeadGestaoTela}
      />
      <PrivateRoute
        hasDashboard
        path="/agenda/:agendaIndividual?"
        component={AgendaLeads}
      />
      <PrivateRoute
        path="/painelrmm"
        component={painelRmm}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([574])}
      />
      <PrivateRoute
        hasDashboard
        path="/baixarsenhacomprador"
        component={LancamentoBaixarSenhaComprador}
      />
      <PrivateRoute
        hasDashboard
        path="/parametrospdv/integracao/:id?"
        component={ParametrosIntegracao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([347, 279, 295, 605])
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/parametrospdv/parametrosdetalhes/:id"
        component={ParametrosDetalhes}
      />
      <PrivateRoute
        hasDashboard
        path="/parametrospdv"
        component={ParametrosPDV}
      />
      {/* W-0645 — Parâmetros do sistema > Fusão (char 630 = gate de migração LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_PARAMETROS_SISTEMA_FUSAO}
        component={ParametrosFusao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(caracteristicas.Sis_parametros)
        }
        exact
      />
      {/* DW-0999 — Parâmetros > Contatos de Teste (característica 725) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_PARAMETROS_CONTATOS_TESTE}
        component={ParametrosContatosTeste}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTATOS_TESTE)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/tagsatendimento"
        component={TagsAtendimento}
      />
      <PrivateRoute
        hasDashboard
        path="/roleta/leads"
        component={RoletaLeads}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([577])}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/alcadas"
        component={RelatorioAlcadas}
        exact
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/usuarios"
        component={Usuarios}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([5, 612, 661])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/novo"
        component={ConfiguracoesUsuarios}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([5])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/grupos"
        component={GruposUsuario}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([5])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/caracteristicas"
        component={Caracteristicas}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(5)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/portador"
        component={PortadorUsuario}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([615])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/hierarquia"
        component={HierarquiaComercial}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([619], [495])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/usuarios/:id"
        component={ConfiguracoesUsuarios}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([5, 612, 661])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/posvenda"
        component={RelatorioPosVenda}
      />
      <PrivateRoute hasDashboard path="/indicacao" component={IndicacaoPage} />
      <PrivateRoute
        hasDashboard
        path="/relatorio/escalas"
        component={RelatorioEscalas}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([577])}
      />
      <PrivateRoute
        hasDashboard
        path="/relatorio/processos-judiciais"
        component={ConsultarProcessosJudiciais}
      />
      <PrivateRoute
        hasDashboard
        path="/impressao/:preVenda"
        component={Impressao}
      />
      <PrivateRoute path="/visualizar-pdf" component={VisualizarPDF} />
      <PrivateRoute
        hasDashboard
        path="/relatorio/conversao/leads"
        component={RelatorioProspectos}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/enquadramento-guarulhos"
        component={EnquadramentoGuarulhos}
        authorizationEvaluator={() => AuthStorage.isADM()}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/ranking-vendas"
        component={RelatorioRankingVendas}
      />
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_VENDAS_DESCONTO}
        component={RelatorioVendasDesconto}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/rescisoes"
        component={RelatorioRescisoes}
        authorizationEvaluator={() => AuthStorage.isADM()}
        exact
      />
      <PrivateRoute
        hasDashboard
        path={`/usuario/alterar-senha`}
        component={AlterarSenha}
      />
      {/* Gerador de Assinatura de E-mail — migração de WebImob2015/Assinatura.aspx.
          Sem característica: qualquer usuário autenticado acessa. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROTA_GERADOR_ASSINATURA_EMAIL}
        component={GeradorAssinaturaEmail}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/leads/inatividade"
        component={RelatorioInatividadeLeads}
      />
      <PrivateRoute
        hasDashboard
        path="/prospecto/gerenciamento-massa"
        component={GerenciamentoMassa}
      />
      <PrivateRoute
        path="/lotes-disponiveis/:familia"
        component={LotesDisponiveis}
      />
      <PrivateRoute
        hasDashboard
        path="/relatorio/auto-atendimento"
        component={RelatorioAutoAtendimento}
      />
      <PrivateRoute
        hasDashboard
        path="/precificacao-ativos"
        component={PrecificacaoAtivosPage}
      />
      <PrivateRoute
        hasDashboard
        path="/ativos"
        component={AtivoManutencao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/imobilizado/lancar-compra"
        component={LancamentoCompraImobilizado}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(93)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/casas-disponiveis"
        component={CasasDisponiveis}
      />
      <PrivateRoute
        hasDashboard
        path="/imoveis-disponiveis"
        component={ImoveisDisponiveis}
      />
      <PrivateRoute
        path="/empreendimentos-conta-bancaria/:familia"
        component={EmpreendimentosContaBancaria}
      />
      <PrivateRoute
        hasDashboard
        path="/relatorio/solicitacoes-cessoes"
        component={SolicitacoesCessoes}
      />
      <PrivateRoute
        path="/relatorio/gestao-rescisoes"
        component={GestaoRescisoes}
        hasDashboard
      />
      <PrivateRoute
        path="/relatorio/imoveis-rescindidos"
        component={ImoveisRescindidos}
        hasDashboard
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
      />
      <PrivateRoute
        path="/imob/relatorios/imoveis-vendidos"
        component={ImoveisVendidos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        hasDashboard
      />
      <PrivateRoute hasDashboard path="/lancamento/mesas" component={Mesas} />
      <PrivateRoute
        hasDashboard
        path="/sismac/ficha-empreendimentos/"
        component={FichaEmpreendimentos}
      />
      <PrivateRoute
        hasDashboard
        path="/lancamento/colaborador/atendimento"
        component={DefinirMesaEAtendimento}
        authorizationEvaluator={() => AuthStorage.isAtendenteLancamento()}
      />
      <PrivateRoute
        hasDashboard
        path="/atendimento/ocorrencias-imoveis"
        component={OcorrenciasImoveis}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
      />

      <PrivateRoute
        hasDashboard
        path="/consulta/ocorrencias-contas"
        component={ConsultaOcorrenciasContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.isADM()
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/relatorio/leads-vendas/"
        component={RelatorioLeadsVendas}
      />
      <PrivateRoute
        hasDashboard
        path="/autoatendimento/escritura/solicitacoes"
        component={SolicitacoesEscritura}
      />
      <PrivateRoute
        hasDashboard
        path="/lancamento/treinamento"
        component={Treinamento}
      />
      <PrivateRoute
        hasDashboard
        path="/empreendimentos/base-conhecimento"
        component={BaseConhecimento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorios"
        component={HubRelatorios}
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/campanhas"
        component={Campanhas}
      />
      {/* W-0534: Cadastro de Alíneas — char 630 portão de migração. */}
      <PrivateRoute
        hasDashboard
        path="/configuracoes/tabelas/alinea"
        component={CadastroAlinea}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/tabelas/ramos_atividade"
        component={RamosAtividade}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ges/contas/tabelas/tipo-conta-interna"
        component={TipoContaInterna}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([
            caracteristicas.ManutencaoTipoContaInterna,
          ])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/categoria-departamento"
        component={CategoriaDepartamento}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([629])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/tabelas/categorias"
        component={CategoriasContas}
        authorizationEvaluator={() =>
          AuthStorage && AuthStorage.temCaracteristicas([630])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/departamentos"
        component={Departamento}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([261])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/cadastros/parcerias"
        component={Parcerias}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([caracteristicas.Parcerias])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/centro-de-custo"
        component={CentroCusto}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([573])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/paises"
        component={Paises}
        authorizationEvaluator={() =>
          AuthStorage && AuthStorage.temCaracteristicas([630])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/cadastros/parcerias/:codigo"
        component={EdicaoParceria}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristicas([caracteristicas.Parcerias])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/cotacoes"
        component={Cotacoes}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([48])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/configuracoes/tabelas/regioes"
        component={Regioes}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristicas([261])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/despesa-tipo-pagamento"
        component={DespesaTipoPagamento}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([573])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/remanejamento-caixa"
        component={RemanejamentoCaixa}
        authorizationEvaluator={() =>
          AuthStorage &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([475])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/mapa-empreendimento"
        component={MapaEmprendimento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([200, 201, 277], [224])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/simulador-financeiro"
        component={SimuladorFinanceiro}
      />
      <PrivateRoute
        hasDashboard
        path="/autoriza-venda-pendencia-juridica"
        component={ReservasPendentes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(
            caracteristicas.AprovaVendaPendenciaJuridica
          )
        }
      />
      <PrivateRoute
        hasDashboard
        path="/fila-lote/:familia?/:ativo?/:quadra?/:lote?"
        component={FilaLote}
      />
      <PrivateRoute
        exact
        path="/lancamento/pre-encaminhamento"
        component={PreEncaminhamento}
        hasDashboard={true}
      />
      <PrivateRoute
        exact
        path="/lancamento/encaminhamento"
        component={Encaminhamento}
        hasDashboard
      />
      <PrivateRoute
        exact
        path="/lancamento/encaminhamento-assinatura"
        component={EncaminhamentoAssinatura}
        hasDashboard
      />
      <PrivateRoute
        hasDashboard
        path="/lancamento/cadastro-rapido"
        component={LancamentoCadastroRapido}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/relatorio/conferencia"
        component={RelatorioConferencia}
      />
      {!isAmbienteProducao() && (
        <PrivateRoute
          hasDashboard
          path="/configuracoes/renegociacao"
          component={ParametrosRenegociacao}
          authorizationEvaluator={() =>
            AuthStorage.temCaracteristicaParametrosRenegociacao()
          }
        />
      )}
      <PrivateRoute
        hasDashboard
        path="/relatorio/vendas-imobiliaria"
        component={RelatorioVendasImobiliaria}
      />

      <PrivateRoute
        hasDashboard
        path="/consulta-acesso"
        component={ConsultaAcesso}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([389, 595, 596, 611, 656])
        }
      />

      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/vendas-empreendimento"
        component={RelatorioVendasEmpreendimento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/vendas-trimestre"
        component={RelatorioVendasTrimestre}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/atendimento-lancamento"
        component={RelatorioAtendimentoLancamento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/visao-lancamento"
        component={VisaoLancamento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/relatorio-estoque"
        component={RelatorioEstoque}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/motivos-nao-compra"
        component={RelatorioMotivosNaoCompra}
      />
      <PrivateRoute
        hasDashboard
        path="/relatorios/vendas-valor-vista"
        component={RelatorioVendasValorVista}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([20])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/interesses-por-lote"
        component={RelatorioInteressesLote}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/comissao-corretor"
        component={ComissaoCorretor}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/prospectos-pastas"
        component={RelatorioProspectosPastas}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/pesquisa-prospecto"
        component={RelatorioPesquisaProspecto}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/lancamento"
        component={RelatorioLancamento}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/fila-lote"
        component={RelatorioFilaLote}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/debitos-creditos"
        component={RelatorioDebitos}
        authorizationEvaluator={() =>
          AuthStorage.isCorretor() || AuthStorage.temCaracteristicas([224, 201])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/relatorio/cidades"
        component={RelatorioCidades}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([19])}
        exact
      />

      {/* W-0491 — Lista de Ocorrências de Contas (admin-only; Gate 1B Q-01=E) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_OCORRENCIAS_CONTAS}
        component={OcorrenciasContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.isADM()
        }
        exact
      />
      {/* W-0587 — Relatório de Cidades por Região (ADR-001: reusa característica 19) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_CIDADES_REGIAO}
        component={RelatorioCidadesPorRegiao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARAC_MANUTENCAO_CIDADES]) &&
          AuthStorage.temCaracteristicas([caracteristicas.MigracaoERP])
        }
        exact
      />

      {/* W-0588 — Relatório de Ramos de Atividade (ADR-003: char 630 provisória — débito técnico HML→DONE) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_RAMOS}
        component={RelatorioRamos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />

      {/* W-0590 - Relatorio Plano de Contas */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_PLANO_CONTAS}
        component={RelatorioPlanoContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />

      {/* W-0594 — Contas Saldo Disponível */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/contas-saldo-disponivel"
        component={ContasSaldoDisponivel}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(8) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/cadastros/cidades"
        component={Cidades}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([19])
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/cadastros/imobiliarias"
        component={CadastroImobiliarias}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([caracteristicas.CadastraImobiliaria])
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/relatorios/despesa-depto"
        component={RelDespesaDeptoPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([21])
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/relatorios/digitalizacoes"
        component={RelDigitalizacaoPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.isADM()
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/financeiro/relatorios/despesas-analitico"
        component={RelatorioDespesasAnalitico}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([
            caracteristicas.RelDespesasAnalitico,
          ]) && AuthStorage.temCaracteristicas([caracteristicas.MigracaoERP])
        }
        exact
      />

      {/* W-0528 — Relatório de Famílias de Ativos */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/familias-ativos"
        component={FamiliasAtivosRelatorio}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristicas([caracteristicas.CriarAlterarFamilia])
        }
        exact
      />

      {/* W-0530: Relatório de Qualidade de Ativos — público dentro de [Authorize] base — ADR-001 */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/qualidades-ativos"
        component={RelatorioQualidadesAtivos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />

      {/* W-0787: Análise Empreendimento — acesso livre (login), fiel ao ERP (lesson W-0509) */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/analise-empreendimento"
        component={RelatorioAnaliseEmpreendimento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />

      {/* W-0583: Relatório Lista de Ativos — característica 35 (AtualizaAtivos) — ADR-001 */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/lista-ativos"
        component={ListaAtivos}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([630])}
        exact
      />

      {/* W-0805 — Cobrança > Re-Financiamentos em Inadimplência. RN-14: relatório sem
          característica própria; char 630 (MigracaoERP) é o portão de migração HML
          (LICOES §1.8), ortogonal a RBAC — remover na promoção HML→DONE. */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/cobranca/refinanciamentos-inadimplencia"
        component={RefinanciamentosInadimplencia}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/relatorios/variantes-ativo"
        component={RelatorioVariantesAtivoPage}
        exact
      />

      {/* W-0584 — GES > Relatórios > Ativos > Ativo por Família */}
      {/* LICOES §1.8: char 630 portão de migração — remover na promoção HML→DONE final */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/ativo-familia"
        component={RelatorioAtivoFamilia}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([630])}
        exact
      />

      {/* W-0840 — Pro-Fit > Relatórios > Comissão de Imóveis */}
      {/* LICOES §1.8: char 630 portão de migração — remover na promoção HML→DONE final */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/comissao-imoveis"
        component={RelatorioComissaoImoveis}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RELAT_COMISSAO_IMOVEIS)
        }
        exact
      />

      {/* W-0477 — Relatório Comissão Retida */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/comissao-retida"
        component={ComissaoRetida}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR])
        }
        exact
      />

      <PrivateRoute
        hasDashboard
        path="/comercial/controle-brindes"
        component={ControleBrindes}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/consultar-saldos"
        component={ConsultarSaldos}
        authorizationEvaluator={() =>
          AuthStorage.isCorretor() || AuthStorage.temCaracteristicas([190, 201])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/tabela-precos"
        component={TabelaPrecos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([617])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/empreendimento"
        component={EmpreendimentoConfig}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([129])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/qualidade-ativo"
        component={QualidadeAtivo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([617])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/qualidades"
        component={QualidadesAtivo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/importacao-xls"
        component={ImportacaoAtivos}
        authorizationEvaluator={function() {
          return (
            AuthStorage.temCaracteristica(630) &&
            AuthStorage.temCaracteristicas([35])
          );
        }}
      />
      <PrivateRoute
        hasDashboard
        path="/ges/contas/manutencao/importacao-xls-contas"
        component={ImportacaoContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_IMPORTACAO_XLS_CONTAS)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/cadastro/ajustar-dados-imoveis"
        component={AjustarDadosImoveis}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/importacao-xls"
        component={ImportacaoAtivos}
        authorizationEvaluator={function() {
          return (
            AuthStorage.temCaracteristica(630) &&
            AuthStorage.temCaracteristicas([35])
          );
        }}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/pdv"
        component={CadastroPdv}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/intencoes-vendas"
        component={IntencoesVendas}
        authorizationEvaluator={() =>
          AuthStorage.isADM() &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/consulta-imoveis"
        component={ConsultaImoveis}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/auditoria/log-atualizacoes"
        component={LogAtualizacoes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([616])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ferramentas/grupo-empresa/:codigo"
        component={GrupoEmpresaDetalhes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([293], [316]) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ferramentas/grupo-empresa"
        component={GrupoEmpresa}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([293], [316]) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ferramentas/cadastro-unico-fornecedor"
        component={CadastroUnicoFornecedor}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
      />
      <PrivateRoute
        hasDashboard
        path="/contas/novo"
        component={ContaDetalhe}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/contas/:ge/:codigo"
        component={ContaDetalhe}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/contas"
        component={ContaListagem}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/ferramentas/contas-salario"
        component={ContasSalario}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([375])
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/empreendimentos/restringir-acesso"
        component={RestringirAcesso}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(621) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/grupo-familias"
        component={GrupoFamilias}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/familias-ativos"
        component={FamiliasAtivos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/ativo/variantes"
        component={VariantesAtivo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(630) &&
          AuthStorage.temCaracteristicas([35])
        }
      />
      <PrivateRoute hasDashboard path="/faq" component={FAQ} />
      <PrivateRoute
        hasDashboard
        exact
        path="/atendimento/comunicado-quitacao"
        component={ComunicadoQuitacao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([525])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/atendimento/debitos-municipais"
        component={DebitosMunicipais}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([372])
        }
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/tabelas/feriados"
        component={Feriados}
        exact
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />

      <PrivateRoute
        hasDashboard
        path="/configuracoes/tabelas/contas-usuario"
        component={ContasUsuario}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/contas-bloqueadas-extrato"
        component={ContasBloqueadasExtrato}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristica(caracteristicas.LiberaExtrato)
        }
      />
      <PrivateRoute
        hasDashboard
        path="/solicitacoes"
        component={Solicitacoes}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/documentos-venda"
        component={DocVenda}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
      />
      <PrivateRoute
        hasDashboard
        path="/comercial/redutores-desconto"
        component={RedutoresDesconto}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([448]) ||
          AuthStorage.temCaracteristicas([239]) ||
          AuthStorage.temCaracteristicas([630])
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/ges/aprovacao-pagamentos"
        component={AprovacaoPagamentos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas(CARACTERISTICAS_APROVACAO_DESPESA)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/ferramentas/digitalizacao"
        component={Digitalizacao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />

      {/* W-0526 — GES > Negócios > Autoriza Despesa/Projetos — char 630 AND (165|265|259|258) em HML (PRD §3) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_AUTORIZA_DESPESA}
        component={AutorizaDespesa}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas(CARACTERISTICAS_APROVACAO_DESPESA)
        }
        exact
      />

      {/* W-0490 — Transferência de Ocorrências (GES > Ferramentas) — char 630 portão de migração + característica nova (LICOES §1.8 / §1.11) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_TRANSFERENCIA_OCORRENCIAS}
        component={TransferenciaOcorrencias}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_TRANSFERENCIA_OCORRENCIAS
          )
        }
        exact
      />

      {/* W-0580 — Relatório de Alíneas (gate 630 — visibilidade migração) */}
      <PrivateRoute
        hasDashboard
        path="/ges/relatorios/titulos/alinea"
        component={AlineaPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      {/* W-0593 — Relatório Centro de Custo — char 630 portão de migração (LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path="/ges/relatorios/contas/centro-custo"
        component={RelCentroCusto}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_REL_CENTRO_CUSTO)
        }
        exact
      />
      {/* W-0595 — Lista de Negócios — par char 630 (migração) + char 83 (acesso Negócio),
          espelha RelNegociosController.TemAcesso() */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_REL_NEGOCIOS}
        component={RelNegocios}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_REL_NEGOCIOS_ACESSO)
        }
        exact
      />
      {/* W-0627 — Relatório Carteira por Conta Capital — char 630 portão de migração (LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_CARTEIRA_CONTA_CAPITAL}
        component={CarteiraPorContaCapital}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CARTEIRA_CONTA_CAPITAL)
        }
        exact
      />
      {/* W-0617 — Mapeamento Geral Estoque — sem RBAC (ERP não controla acesso, gate-1a). */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_MAPEAMENTO_GERAL_ESTOQUE}
        component={MapeamentoGeralEstoque}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      {/* W-0607 — Consulta Aniversariantes (read-only). Gate AND char 630 (migração) +
          647 (Consulta Aniversariantes/LGPD) — espelha AniversariantesController.PossuiPermissao().
          647 oculta a tela até o DBA cadastrar; LICOES §1.8: remover gate 630 na promoção HML→DONE. */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_CONSULTA_ANIVERSARIANTES}
        component={Aniversariantes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONSULTA_ANIVERSARIANTES)
        }
        exact
      />
      {/* W-0604 — GES Etiquetas/Cartas — produção liberada em 2026-07-27.
          VALUE-GATE: mantém somente char 236 (Relatório Dados Cliente). */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ETIQUETAS_CARTAS}
        component={EtiquetasCartas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_RELATORIO_CONTAS)
        }
        exact
      />
      {/* W-0779 — Relatório Razão Social (Imob > Relatórios > Contábil).
          RBAC característica 694 Relatorio_Razao_Social (Q-01=A — dados sensíveis CNPJ/sócios/capital). */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELATORIO_RAZAO_SOCIAL}
        component={RazaoSocial}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RELATORIO_RAZAO_SOCIAL)
        }
        exact
      />
      {/* W-0489 — Consulta de Ocorrências de Ativos.
          Paridade Delphi: sem RBAC granular (ProjetoMAIN.PAS:4685 nao chama AutorizaUsuario).
          Char 630 (HOMOLOGADOR) eh portao de migracao HML (LICOES §1.8 — remover ao promover DONE). */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_CONSULTA_OCORRENCIAS_ATIVO}
        component={ConsultaOcorrenciasAtivoPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      {/* W-0928 — Relatório Audit: Contas sem saldo conferido — char 630 portão (LICOES §1.8) + char 660 (ADR-001) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_RELAT_CONTAS_SEM_SALDO_CONF}
        component={ContasSemSaldoConferido}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_RELAT_CONTAS_SEM_SALDO_CONF
          )
        }
        exact
      />
      {/* ⚠️ Sem authorizationEvaluator — tela pública, paridade ERP (W-0557 Q-04=A) */}
      <PrivateRoute
        hasDashboard
        path="/financeiro/relatorio/alinea"
        component={AlineaPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      {/* ⚠️ Sem authorizationEvaluator — tela pública, paridade ERP (W-0557 Q-04=A) */}
      <PrivateRoute
        hasDashboard
        path="/ges/simulacao-proposta"
        component={SimulacaoProposta}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      {/* W-0551 — Baixa Título por Data (LICOES §1.8: [630, 635] durante migração; remover 630 ao liberar) */}
      <PrivateRoute
        hasDashboard
        path="/ges/negocios/titulos/baixa-por-data"
        component={BaixaPorData}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_BAIXA_TITULO)
        }
        exact
      />
      {/* W-0554 — Correção de Títulos a Pagar — char 630 portão de migração + RBAC (LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path="/ges/negocios/titulos/correcao"
        component={CorrecaoTitulos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />

      {/* W-0599 — Histórico Padrão */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_HISTORICO_PADRAO}
        component={HistoricoPadraoGES}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />

      {/* W-0563 — Cadastro de Cartões — char 630 portão de migração (LICOES §1.8) */}
      {/* W-0579 — Relatório de Cheques Devolvidos (Sem authorizationEvaluator — ADR-002 W-0579) */}
      <PrivateRoute
        hasDashboard
        path="/ges/relatorios/titulos/cheques-devolvidos"
        component={ChequesDevolvidosPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />

      {/* W-0563 — Cadastro de Cartões — char 630 portão de migração (LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path="/ges/cartoes"
        component={Cartoes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CADASTRO_CARTAO_TAXA)
        }
        exact
      />

      {/* W-0624 — Perfil de Carteira por Faixa de Valor */}
      <PrivateRoute
        hasDashboard
        path="/gerencial/carteira/perfil-faixa"
        component={PerfilCarteiraPorFaixa}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/procuracoes"
        component={Procuracoes}
        authorizationEvaluator={function() {
          return AuthStorage.temCaracteristicas([627]);
        }}
      />
      {/* W-0659 — Exportação e Importação de Cotação Moeda Forte (ADR-001: característica 644) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_EXP_IMP_COTACAO_MOEDA_FORTE}
        component={ExportacaoImportacaoCotacaoMoedaForte}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACT_EXP_IMP_COTACAO_MOEDA_FORTE)
        }
        exact
      />
      {/* W-0652 — Altera Nome Ativo (char 35 AtualizaAtivo + char 630 portão de migração — LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ALTERA_NOME_ATIVO}
        component={AlteraNomeAtivo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(caracteristicas.AtualizaAtivo)
        }
        exact
      />
      {/* W-0663 — Acerta contas de despesas/receitas — gate transitório [630, 645] (Setpar §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ACERTAR_CONTA}
        component={AcertarConta}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ACERTAR_CONTA)
        }
        exact
      />
      {/* W-0651 — Altera Código Conta (destrutiva) — gate transitório [630, 31] (Setpar §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ALTERAR_CODIGO_CONTA}
        component={AlterarCodigoConta}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ALTERAR_CODIGO_CONTA)
        }
        exact
      />
      {/* W-0654 — Altera Código Departamento (irreversível) — gate transitório [630, 677] (Setpar §1.8) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_ALTERAR_CODIGO_DEPARTAMENTO}
        component={AlterarCodigoDepartamento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_ALTERAR_CODIGO_DEPARTAMENTO
          )
        }
        exact
      />
      {/* W-0664 — Fechamento de Caixa (GES > Ferramentas) — char 191 + char 630 (gate UAT) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_FECHAMENTO_CAIXA}
        component={FechamentoCaixa}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_FECHA_CAIXA)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/imob/isencoes-cobranca"
        component={IsencaoCobranca}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(COBRANCA_IMOVEL) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/rastreamento-titulos"
        component={RastreamentoTitulos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RASTREAMENTO_TITULOS)
        }
      />
      {/* W-0533 — Manutenção de Títulos (LICOES §1.8 char 630 portão migração HML) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/manutencao-titulos"
        component={ManutencaoTitulos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_MANUTENCAO_TITULO)
        }
      />
      {/* W-0582 — Relatório Cotação Moeda Forte (ADR-001: característica 48) */}
      <PrivateRoute
        hasDashboard
        path={'/relatorio-cotacao-moeda-forte'}
        component={RelatorioCotacaoMoedaForte}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(48)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path={ROUTE_COTACOES_MOEDA_FORTE}
        component={CotacoesMoedaForte}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      {/* W-0682 — Declaração de Quitação (ADR-003: característica MigracaoERP=630) */}
      <PrivateRoute
        hasDashboard
        path="/imob/atendimento/declaracao-quitacao"
        component={DeclaracaoQuitacao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/despesa-cartao-credito"
        component={DespesaCartaoCredito}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/negocios/fechamento-cartao-credito"
        component={FechamentoCartaoCredito}
        authorizationEvaluator={() =>
          !!AuthStorage.getUser() &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      {/* W-0684 — Tipo de Atendimento (Imob) */}
      <PrivateRoute
        hasDashboard
        path="/imob/atendimento/tipo-atendimento"
        component={TipoAtendimento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(TIPO_ATENDIMENTO_CARACTERISTICA) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      {/* W-0724 — Portador Jurídico (Imob > Jurídico) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_PORTADOR_JURIDICO}
        component={PortadorJuridico}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_PORTADOR_JURIDICO)
        }
        exact
      />
      {/* W-0753 — Imob > Relatórios > Ficha de Empreendimento (ADR-001 — isAdm) */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/imob/ficha-empreendimento"
        component={FichaEmpreendimentoRelatorio}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.isAdm()
        }
        exact
      />
      {/* W-0750 — Imob > Relatórios > Administração > Etiquetas Imóveis (read-only) */}
      {/* char 630 portão de migração — remover na promoção HML→DONE final */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/administracao/etiquetas-imoveis"
        component={EtiquetasImoveis}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([630])}
        exact
      />
      {/* W-0743 — Imob > Relatórios > Administração > Atualização Cadastral Prefeitura/Água.
          VALUE-GATE: promoção para produção confirmada em 2026-07-27; mantém somente char 236. */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/atualizacao-cadastral"
        component={AtualizacaoCadastral}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_RELATORIO_DADOS_CLIENTE)
        }
        exact
      />
      {/* W-0852 — Simula Comissão Cobrança (Pro-Fit > Cobrança > Relatórios). Simulador read-only.
          RBAC literal [Authorize] — aberto a qualquer autenticado, sem gate de característica
          (handler ERP UPrincipal.pas:6281 não tem AutorizaUsuario). */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROTA_SIMULA_COMISSAO_COBRANCA}
        component={SimulaComissaoCobranca}
      />
      {/* W-0626 — Demonstrativo Financeiro / Carteira.
          Gate: char 630 (portão de migração HML) + char 705 (Relat Demonst Financeiro, dedicada). */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/carteira/demonstrativo-financeiro"
        component={DemonstrativoFinanceiroPage}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP) &&
          AuthStorage.temCaracteristica(
            caracteristicas.RelatDemonstrativoFinanceiro
          )
        }
        exact
      />
      {/* W-0726 — Contas Isentas Jurídico (Imob > Jurídico) */}
      <PrivateRoute
        hasDashboard
        path={ROUTE_CONTAS_ISENTAS_JURIDICO}
        component={ContasIsentasJuridico}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ACESSO_JURIS)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/controle-contrato"
        component={ControleContrato}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.ControleContrato) &&
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/prestadores"
        component={PrestadoresHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/fechamento"
        component={FechamentoHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/contratos"
        component={ContratosHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/fundos"
        component={FundosHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/rescisao"
        component={RescisaoHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/juridico/horas-pj/relatorios"
        component={RelatoriosHorasPJ}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTROLE_HORAS_PJ)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/matricial-despesas/usuario-alternativo"
        component={UsuarioAlternativoMatricial}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristicas([261])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/matricial-despesas/periodos"
        component={MatricialPeriodos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(260) &&
          AuthStorage.temCaracteristica(630)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/negocios/nivel-retencao"
        component={NivelRetencao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/atendimento/controle-taxa-transferencia"
        component={ControleTaxaTransferencia}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      {/* W-0691 — Atualiza Taxa de Transferência. BE checa AND [630, 670] (PR #763 + #772).
          670 = "Atualiza Taxa Transferencia" no caracteristica_de_software.csv (corrigido de 695,
          que é "Acesso Senha Aprovacao"). Rota mantém OR [630, 670] como portão de migração durante
          HML (LICOES §1.8); remover CARACTERISTICA_HOMOLOGADOR ao promover HML→DONE. */}
      <PrivateRoute
        hasDashboard
        exact
        path="/administracao/atualiza-taxa-transferencia"
        component={AtualizaTaxaTransferencia}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_ATUALIZA_TAXA_TRANSFERENCIA
          )
        }
      />
      {/* W-0585 — Relatório de Contas */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/contas"
        component={RelatorioContasPage}
        authorizationEvaluator={() => AuthStorage.temCaracteristica(630)}
        exact
      />

      {/* W-0564 — Cadastro de Templates de Rateio (ADR-001 — TEMP W-0564: reavaliar granularidade) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/rateio-template"
        component={RateioTemplate}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RATEIO_TEMPLATE)
        }
      />

      {/* W-0611 — Saldo de Conta Banco */}
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/gerencial/financas/saldo-conta-banco"
        component={SaldoContaBanco}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR])
        }
      />
      {/* W-0612 — Fluxo de Caixa Gerencial */}
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/gerencial/financas/fluxo-caixa"
        component={FluxoCaixa}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RATEIO_TEMPLATE)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/relatorios/fluxo-de-caixa"
        component={FluxoCaixaDw}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([730])
        }
      />
      {/* W-0613 — Posição Sintética Carteira a Receber (gate 630 + característica 692) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/gerencial/financas/posicao-sintetica-carteira-receber"
        component={PosicaoSinteticaCarteiraReceber}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_POSICAO_SINTETICA_CARTEIRA_RECEBER
          )
        }
      />
      {/* W-0879 — Retorno Cobrança BRADESCO sem registro */}
      <PrivateRoute
        hasDashboard
        exact
        path={RETORNO_COBRANCA_BRADESCO}
        component={RetornoCobrancaBradesco}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_RETORNO_BRADESCO)
        }
      />
      {/* W-0882 — Retorno Cobrança - Geral (char 630 portão de migração — ADR-007, LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        exact
        path={RETORNO_COBRANCA_GERAL}
        component={RetornoCobranca}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0881 — Conciliação Bancária - Geral (ADR-001: char 630 portão migração + 662 funcional) */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_CONCILIACAO_BANCARIA}
        component={ConciliacaoBancariaGeral}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONCILIACAO_BANCARIA)
        }
      />
      {/* W-0872 — Relatório Remessa de Boletos — char 630 portão de migração (LICOES §1.8) */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_RELATORIO_REMESSA_BOLETOS}
        component={RelatorioRemessaBoletos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_RELATORIO_REMESSA_BOLETOS
          )
        }
      />
      {/* W-0634 — Manual de Apuração de Resultados (leitura aberta; edição usa char 630 na página) */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_MANUAL_APURACAO}
        component={ManualApuracao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0560 — Reapresentação de Cheques Devolvidos (ADR-002 / LICOES §1.8 char 630 portão migração) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/ges/reapresentacao-cheques"
        component={ReapresentacaoCheques}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARAC_REAPRESENTAR_CHEQUES)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/comunicacao/comunicado-email"
        component={ComunicadoInterno}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARAC_COMUNICADO_EMAIL])
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/configuracoes/historico-padrao"
        component={HistoricoPadrao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      {/* W-0710 — Cancelar Proposta Mista (Imob > Comercial) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/cancelamento-mista"
        component={CancelamentoMista}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CANCELA_PROPOSTA_MISTA)
        }
      />
      {/* W-0693 — Alertas de Empreendimentos (Imob > Administração) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/alertas-empreendimento"
        component={AlertasEmpreendimentos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0821 — Transferir títulos para cobrança (Imob > Cobrador) */}
      {/* Char 630 portão de migração + (125 OU 126) acesso operacional/gerencial */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_TRANSF_COBRANCA}
        component={TransferirTitulos}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          (AuthStorage.temCaracteristica(CARACTERISTICA_COBRADOR_GERENCIAL) ||
            AuthStorage.temCaracteristica(CARACTERISTICA_COBRADOR_OPERACIONAL))
        }
      />
      {/* W-0829 — Resultado de Atendimento (Imob > Cobrador). Característica 291. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_RESULTADO_ATENDIMENTO}
        component={ResultadoAtendimento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(RBAC_RESULTADO_ATENDIMENTO)
        }
      />
      {/* W-0759 — Imóveis em Estoque (Relatório Comercial Imob).
          VALUE-GATE: promoção para produção confirmada em 2026-07-27; mantém somente char 724. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_IMOVEIS_ESTOQUE}
        component={ImoveisEstoque}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.ImoveisEstoque)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/financeiro/contas-intercambio"
        component={ContasIntercambio}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([MATRICIAL_CONTROLADORIA])
        }
      />
      {/* W-0698 — Monitoramento de clientes (Imob/Administração) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/monitora"
        component={Monitora}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_MONITORAMENTO)
        }
      />
      {/* W-0713 — Gerenciamento de E-mail (Imob > Comercial) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/comercial/gerenciamento-email"
        component={GerenciamentoEmail}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(MENU_GERENCIA_EMAIL)
        }
      />
      {/* W-0733 — Ata Contábil (Imob > Contábil) — característica 252 */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/contabil/ata-contabil"
        component={AtaContabil}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_ATA_CONTABIL)
        }
      />
      {/* W-0539 — Contas Prefeitura Sem Convênio (GES > Ferramentas).
          Delphi não tinha RBAC (vide LICOES §1.8 + comment em links.js); durante HML usa apenas
          char 630 (CARACTERISTICA_HOMOLOGADOR). Plano de remoção char 630 ao HML→DONE em
          GATES_PRE_MERGE_RODADA.md. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_CONTAS_PREFEITURA_SEM_CONVENIO}
        component={ContasPrefeituraSemConvenio}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0683 — Local de Atendimento (Imob > Atendimento). Char 630 removida ao promover HML→DONE (ADR-008). */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/local-atendimento"
        component={LocalAtendimento}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_LOCAL_ATENDIMENTO)
        }
      />
      {/* W-0777 — Imob > Relatórios > Contábil > Estoque Disponível */}
      {/* char 630 (CARACTERISTICA_HOMOLOGADOR) = portão de migração; remover na promoção HML→DONE. */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/relatorio/estoque-contabil"
        component={RelatorioEstoqueContabil}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0531 — Solicita Reembolso Clientes (IPTU) — Imob > Administração */}
      {/* chars 666 (implanta reembolsáveis) + 630 (portão migração) — AND explícito (FE-006) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/imob/reembolso-iptu"
        component={ReembolsoIptu}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(
            CARACTERISTICA_IMPLANTA_REEMBOLSAVEIS
          ) && AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0935 — Audit > Títulos > Cheques Prorrogados */}
      {/* [100, 630] = char Auditoria + portão de migração (LICOES §1.8). */}
      {/* Remover 630 na promoção HML→DONE com liberação geral. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_CHEQUES_PRORROGADOS}
        component={ChequesProrrogados}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_AUDITORIA)
        }
      />
      {/* W-0937 — Audit > Histórico de Imóveis */}
      {/* [100, 630] = char Auditoria + portão de migração (LICOES §1.8). */}
      {/* Remover 630 na promoção HML→DONE com liberação geral. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_HISTORICO_IMOVEIS}
        component={HistoricoImoveis}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_AUDITORIA) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0858 — Relacionamento de Contas (Generate > Manutenção) */}
      {/* ADR-001: char compartilhada 708 + char 630 portão de migração */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_RELACIONAMENTO_CONTAS}
        component={RelacionamentoContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_GENERATE_MANUTENCAO)
        }
      />
      {/* W-0883 — Consulta Protocolo de Remessas (Generate > Consulta) */}
      {/* Read-only. Sem char próprio (espelha GES); gate só na 630 (MigracaoERP) */}
      <PrivateRoute
        hasDashboard
        exact
        path="/generate/protocolo-remessas"
        component={ProtocoloRemessas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristicas([CARACTERISTICA_HOMOLOGADOR])
        }
      />
      {/* W-0540 — Saldos de Contas (GES > Contas > Saldos de Contas) */}
      {/* Char 630 portão de migração (LICOES §1.8) — remover na promoção HML→DONE */}
      {/* AND duplo: temCaracteristicas([...]) é OR — usar temCaracteristica singular em série */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_SALDOS_CONTAS}
        component={SaldosContas}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CHAR_SALDO_CONTAS_CONFERIR)
        }
      />
      {/* W-0657 — Lista de E-mail de Clientes (GES > Ferramentas).
          ADR-001: sem RBAC funcional; char 630 é portão de migração. */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_LISTA_EMAIL_CLIENTES}
        component={ListaEmailClientes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* DW-0996 — Sistema RSVP Eventos (Admin CRM).
          ADR-002: CRUD admin no CRM, característicacost 671 exclusiva (marketing).
          JWT do CRM, não token público X-Evento-Rsvp-Token. */}
      <PrivateRoute
        hasDashboard
        exact
        path={`${ROUTE_EVENTOS_RSVP}/novo`}
        component={EventoRsvpForm}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path={`${ROUTE_EVENTOS_RSVP}/:id/editar`}
        component={EventoRsvpForm}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_EVENTOS_RSVP}
        component={EventoRsvpList}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP)
        }
      />
      {/* DW-0998 — Check-in de Evento (portaria). Caract. 671 (RSVP) ou 687 (Entrega). */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_EVENTO_RSVP_CHECKIN}
        component={EventoRsvpCheckin}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP) ||
          AuthStorage.temCaracteristica(CARACTERISTICA_CHECKIN_PESQUISA_EVENTO)
        }
      />
      {/* DW-0998 — Pesquisas Entrada/Saída SetGarden.
          Gating: isAdm OU 671 (RSVP) OU 687 (Checkin/Pesquisa Entrega). */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_PESQUISA_EVENTO}
        component={PesquisaEvento}
        authorizationEvaluator={() =>
          AuthStorage.isAdm() ||
          AuthStorage.temCaracteristica(CARACTERISTICA_EVENTO_RSVP) ||
          AuthStorage.temCaracteristica(CARACTERISTICA_CHECKIN_PESQUISA_EVENTO)
        }
      />
      <PrivateRoute
        hasDashboard
        exact
        path="/relatorios/contratos/com-construcao"
        component={ContratoConstrucao}
      />
      <PrivateRoute
       hasDashboard
       path="/juridico/solicitacoes"
       component={SolicitacoesJuridicas}
       authorizationEvaluator={() =>
         AuthStorage.isADM() ||
         AuthStorage.isAdm() ||
         AuthStorage.temCaracteristica(449)
       }
       exact
      />

      <PrivateRoute
        hasDashboard
        path="/ferramentas/validador-assinatura-digital"
        component={ValidadorAssinaturaDigital}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(
            CARACTERISTICA_VALIDADOR_ASSINATURA_DIGITAL
          )
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/cartao-credito"
        component={CartaoCredito}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(506)
        }
        exact
      />
      <PrivateRoute
        hasDashboard
        path="/atualizar-vencimento-titulo"
        component={AtualizaVencimentoTitulo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(85)
        }
        exact
      />
      {/* W-0543 — Contas de Difícil Liquidação (GES > Contas > Tabelas) */}
      <PrivateRoute
        hasDashboard
        exact
        path={ROUTE_CONTAS_DIF_LIQ}
        component={ContasDificilLiquidacao}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR) &&
          AuthStorage.temCaracteristica(CARACTERISTICA_CONTAS_DIF_LIQ)
        }
      />

      <PrivateRoute
        hasDashboard
        path="/relatorios/relatorio-debitos-municipais"
        component={RelDebitosMunicipais}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(
            CARACTERISTICA_RELATORIO_DEBITOS_MUNICIPAIS
          )
        }
      />
      <PrivateRoute
        hasDashboard
        path="/administracao/alertas-clientes"
        component={AlertasClientes}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(CARACTERISTICA_HOMOLOGADOR)
        }
      />
      {/* W-0804 — Acordos de cobrança não concretizados (Relatórios > Cobrança). Read-only.
          Char 630 (MigracaoERP) é o portão de migração — gate em rota E menu (defesa em
          profundidade). RBAC de dados (pezao/sojuris) fica no backend, só filtra o combo de cobrador. */}
      <PrivateRoute
        hasDashboard
        exact
        path="/relatorios/cobranca/acordos-nao-concretizados"
        component={AcordosNaoConcretizados}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      {/* W-0827 — Consulta Acordo Judicial (Cobrador). Read-only single-grid.
          Gate de migração char 630 (MigracaoERP). RBAC 95/125/126 é server-side: o backend
          nega quem não tem nenhuma das 3 chars e escopa o combo de cobradores (pezao/sojuris). */}
      <PrivateRoute
        hasDashboard
        exact
        path="/cobrador/acordo-judicial"
        component={ConsultaAcordoJudicial}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />

      {/* W-0697 — Imob > Administração > Consulta de Imóveis Alugados (read-only) */}
      {/* LICOES §1.8: char 630 portão de migração — remover na promoção HML→DONE final */}
      <PrivateRoute
        hasDashboard
        path="/imob/imoveis-alugados"
        component={ImoveisAlugados}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([630])}
        exact
      />

      {/* W-0775 — Imob > Contábil > Baixa de Título (read-only) */}
      {/* char 630 (MigracaoERP) = portão de migração HML, NÃO é RBAC (RN-14: o .pas não tem char). */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/contabil/baixa-titulo"
        component={BaixaTitulo}
        authorizationEvaluator={() =>
          AuthStorage.temCaracteristica(caracteristicas.MigracaoERP)
        }
      />
      {/* W-0817 — Imob > Relatórios > Cobrança > Conciliação dos Recebimentos (read-only) */}
      {/* char 630 = portão de migração HML — remover na promoção HML→DONE final */}
      <PrivateRoute
        hasDashboard
        path="/relatorios/cobranca/conciliacao-recebimentos"
        component={ConciliacaoRecebimentos}
        authorizationEvaluator={() => AuthStorage.temCaracteristicas([630])}
      />
      <Redirect
        to={
          AuthStorage.isAtendenteLancamento()
            ? '/lancamento/colaborador/atendimento'
            : '/comercial/ranking/corretor'
        }
      />
    </Switch>
  </App>
);

export default Routes;
